import React, {
  createContext,
  useContext,
  useCallback,
  useEffect,
  useState,
  useMemo,
} from 'react'
import { useAccountContext } from '~/modules/account/context'

import immutableUpdate from 'immutability-helper'
import { useLazyQuery, useApolloClient, gql } from '@apollo/client'

import { AppContext } from '~/app/providers/App'
import { useCurrentChannel } from '~/app/state/hooks'

/**
 *
 */
// @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 0.
const PostsContext = createContext()

export const POSTS_PER_PAGE = 30

export const FRAGMENT_POST = gql`
  fragment post on EngagePost {
    id
    channelService
    channelServiceId
    text
    mediaUrl
    totalComments
    totalPendingComments
    labelsCount {
      label
      count
    }
    isGiveaway
    createdAt
    commentsUpdatedAt
  }
`

export const QUERY_POSTS = gql`
  query FetchEngagePosts(
    $organizationId: String!
    $channelService: String!
    $channelServiceId: String!
    $filter: PostsFilter
    $first: Int!
    $after: String
  ) {
    engagePosts(
      organizationId: $organizationId
      channelService: $channelService
      channelServiceId: $channelServiceId
      filter: $filter
      first: $first
      after: $after
    ) {
      edges {
        node {
          ...post
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    engageOrganization(organizationId: $organizationId) {
      id
      channels {
        id
        totalComments
        totalPendingComments
        labelsCount {
          label
          count
        }
        backfillingComplete
      }
    }
  }
  ${FRAGMENT_POST}
`

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'children' implicitly has an 'any'... Remove this comment to see the full error message
function PostsProvider({ children }) {
  const [selected, setSelectedPost] = useState(null)

  const [fetch, { data, loading, refetch, fetchMore }] = useLazyQuery(
    QUERY_POSTS,
    {
      fetchPolicy: 'network-only',
    },
  )

  // @ts-expect-error TS(2339) FIXME: Property 'filter' does not exist on type 'unknown'... Remove this comment to see the full error message
  const { filter } = useContext(AppContext)
  const { currentChannel, queryCurrentChannel } = useCurrentChannel()

  const client = useApolloClient()

  const account = useAccountContext()

  useEffect(() => {
    queryCurrentChannel()
  }, [])

  const channelServiceId = currentChannel?.serviceId
  useEffect(() => {
    // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
    if (!account?.id || !currentChannel) {
      return
    }

    // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
    const organization = account.currentOrganization
    if (!organization?.id) {
      return
    }

    fetch({
      variables: {
        channelServiceId,
        organizationId: organization.id,
        channelService: currentChannel.service,
        first: POSTS_PER_PAGE,
        filter,
      },
    })
  }, [account, channelServiceId, filter])

  const loadMore = useCallback(() => {
    const hasNextPage = data?.engagePosts?.pageInfo.hasNextPage
    if (!hasNextPage || loading) return

    fetchMore({
      variables: {
        first: POSTS_PER_PAGE,
        after: data.engagePosts.pageInfo.endCursor,
      },
      // @ts-expect-error TS(2769) FIXME: No overload matches this call.
      fetchPolicy: 'network-only',
      updateQuery: (previousResult, { fetchMoreResult }) => {
        if (!previousResult?.engagePosts) return

        const newEdges = fetchMoreResult?.engagePosts.edges || []
        const pageInfo = fetchMoreResult?.engagePosts.pageInfo

        return {
          engagePosts: {
            __typename: previousResult.engagePosts.__typename,
            edges: [...previousResult.engagePosts.edges, ...newEdges],
            pageInfo,
          },
          engageOrganization: previousResult.engageOrganization,
        }
      },
    })
  }, [data])

  const get = useCallback(
    (postId: string) =>
      client.readFragment({
        id: `EngagePost:${postId}`,
        fragment: FRAGMENT_POST,
      }),
    [client],
  )

  const add = useCallback(
    (post: any) => {
      // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
      const organization = account?.currentOrganization
      if (!organization?.id) {
        return null
      }

      const variables = {
        organizationId: organization.id,
        channelService: currentChannel.service,
        channelServiceId: currentChannel.serviceId,
        first: POSTS_PER_PAGE,
        filter,
      }

      const { engagePosts } = client.readQuery({
        query: QUERY_POSTS,
        variables,
      })

      const { edges = [] } = engagePosts || {}
      const lastPost = edges[edges.length - 1]

      // Only add post if it should be part of the
      // currently paginated data.
      if (new Date(post.createdAt) > new Date(lastPost.node.createdAt)) {
        const newPost = { __typename: 'EngagePost', ...post }

        // @ts-expect-error TS(7006) FIXME: Parameter 'el' implicitly has an 'any' type.
        newPost.labelsCount.forEach((el) => (el.__typename = 'LabelCount'))

        const updatedEdges = [
          ...engagePosts.edges,
          {
            node: newPost,
            cursor: post.id,
            __typename: 'PostEdge',
          },
        ]

        client.writeQuery({
          query: QUERY_POSTS,
          variables,
          data: {
            engagePosts: {
              ...engagePosts,
              edges: updatedEdges.sort((a, b) => {
                return (
                  new Date(b.node.createdAt).getTime() -
                  new Date(a.node.createdAt).getTime()
                )
              }),
            },
          },
        })

        return newPost
      }
    },
    [account, currentChannel, filter],
  )

  // @ts-expect-error TS(2554) FIXME: Expected 2 arguments, but got 1.
  const update = useCallback((id, newValues) => {
    const post = get(id)
    if (!post) {
      return null
    }

    const updateCommands = {}

    Object.keys(newValues).forEach((key) => {
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      updateCommands[key] = { $set: newValues[key] }
    })

    const updatedData = immutableUpdate(post, updateCommands)

    client.writeFragment({
      id: `EngagePost:${id}`,
      fragment: FRAGMENT_POST,
      data: updatedData,
    })

    return updatedData
  })

  const state = useMemo(
    () => ({
      // @ts-expect-error TS(7006) FIXME: Parameter 'edge' implicitly has an 'any' type.
      posts: data?.engagePosts?.edges.map((edge) => edge.node) || null,
      loading,
      loadedAll: !data?.engagePosts?.pageInfo.hasNextPage,
      selected,
    }),
    [data],
  )

  const actions = useMemo(
    () => ({
      loadMore,
      get,
      add,
      update,
      refetch,
    }),
    [loadMore, get, add, update, refetch],
  )

  return (
    <PostsContext.Provider value={[state, actions]}>
      {children}
    </PostsContext.Provider>
  )
}

/**
 *
 */
function usePostsContext() {
  const context = useContext(PostsContext)
  if (context === undefined) {
    throw new Error('usePostsContext must be used within a PostsContext')
  }
  return context
}

export { PostsProvider, usePostsContext }
